// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"128":"dddd33f6","391":"c34c51f5"}[chunkId] + ".chunk.css";
};